// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"244":"f0b42867","262":"5fa2998f","528":"ccbe808e"}[chunkId] + ".chunk.js";
};